
/**
 * @description
 * 로드맵 상세페이지 > 연결된 수업
 */

import { ROADMAP_NAVIGATOR_ID } from '@/utils/enums.js';

import CourseClassList from './CourseClassList.vue';
import CourseProgress from './CourseProgress.vue';

export default {
  name: 'CourseRelatedClass',
  components: { CourseProgress, CourseClassList },
  computed: {
    relatedClassNavId: () => ROADMAP_NAVIGATOR_ID.RELATED_CLASS,
  },
};
